/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import docs from '@salesforce/design-system-react/components/component-docs.json';
import MarkdownRenderer from './markdown-renderer';
import Icon from '@salesforce/design-system-react/components/icon';
import startCase from 'lodash.startcase';

const PropTable = createReactClass({
    displayName: 'PropTable',

    propTypes: {
        items: PropTypes.object,
        component: PropTypes.string
    },

    getInitialState() {
        return {};
    },

    componentWillMount() {
        if (!docs[this.props.component]) {
            return;
        }
    },

    renderEnum(enumType) {
        const enumValues = enumType.value || [];
        const renderedEnumValues = enumValues.map((enumValue, i) => {
            const toReturn = [];
            if (i > 0) {
                toReturn.push(<span key={`${i}c`}> | </span>);
            }

            let val = enumValue.value.replace(/'|"/g, '');
            toReturn.push(<code key={`${i}val`}>{val}</code>);
            return toReturn;
        });

        return <span>string: {renderedEnumValues}</span>;
    },

    renderPropInfo(componentDocs, depName) {
        if (!componentDocs) {
            return false;
        }

        const depNamePrefix = depName ? `${depName}-` : '';

        const props = Object.keys(componentDocs).map(prop => {
            const thisProp = componentDocs[prop];
            const propType = thisProp.type ? thisProp.type : null;
            let row;
            if (propType) {
                const type =
                    propType && propType.name === 'enum'
                        ? this.renderEnum(propType)
                        : thisProp.type;
                let defaultProp = componentDocs[prop].defaultValue
                    ? componentDocs[prop].defaultValue.value.replace(/'|"/g, '')
                    : '';
                let required = componentDocs[prop].required ? (
                    <Icon
                        name="check"
                        category="utility"
                        size="x-small"
                        className="slds-icon-text-default"
                    />
                ) : (
                    ''
                );

                row = (
                    <tr key={prop}>
                        <th
                            id={`prop-${depNamePrefix}${prop}`}
                            scope="row"
                            data-label="Name"
                            className="slds-cell-wrap"
                        >
                            <a
                                className="slds-text-link--reset"
                                href={`#prop-${depNamePrefix}${prop}`}
                            >
                                {prop}
                            </a>
                        </th>
                        <td data-label="Type" className="slds-cell-wrap">
                            {type.name ? type.name : type.props.children}
                        </td>
                        <td data-label="Required" className="site-text--center">
                            {required}
                        </td>
                        <td data-label="Default" className="slds-cell-wrap">
                            <MarkdownRenderer
                                className={null}
                                markdown={defaultProp}
                            />
                        </td>
                        <td data-label="Description" className="slds-cell-wrap">
                            <MarkdownRenderer
                                className={null}
                                markdown={componentDocs[prop].description}
                            />
                        </td>
                    </tr>
                );
            }
            return row;
        });

        return props;
    },

    renderSubComponentInfo() {
        const componentDependencies = docs[this.props.component]
            ? docs[this.props.component].dependencies
            : null;
        if (!componentDependencies || componentDependencies.length === 0) {
            return false;
        }

        const dependencies = [
            <h2
                id="sub-components"
                key="sub-component-details-header"
                className="slds-text-heading--medium slds-m-top--xx-large"
            >
                <a
                    href="#sub-components"
                    className="slds-text-link--reset site-text-heading--callout"
                >
                    Related Sub-Components
                </a>
            </h2>,
            Object.keys(componentDependencies).map(dependency => {
                const thisDependency = componentDependencies[dependency];
                const depName = Object.keys(thisDependency)[0];
                const dep = thisDependency[depName];

                const row = (
                    <div className="slds-p-vertical--large" key={depName}>
                        <h3 className="slds-text-heading--medium slds-p-vertical--small">
                            {startCase(depName)}
                        </h3>
                        <div className="slds-m-bottom--large">
                            <MarkdownRenderer
                                className="site-text-introduction"
                                markdown={dep.description}
                            />
                        </div>

                        {dep.props ? (
                            <div>
                                <h4 className="slds-m-top--small slds-text-heading--small">
                                    Property Details
                                </h4>
                                <table className="slds-table slds-table--bordered slds-no-row-hover slds-m-top--medium slds-border_right slds-border_left">
                                    <thead>
                                        <tr className="slds-text-title--caps">
                                            <th scope="col">Name</th>
                                            <th scope="col">Type</th>
                                            <th
                                                className="site-text--center"
                                                scope="col"
                                            >
                                                Required
                                            </th>
                                            <th scope="col">Default</th>
                                            <th scope="col">Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderPropInfo(
                                            dep.props,
                                            depName
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                    </div>
                );
                return row;
            })
        ];

        return dependencies;
    },

    render() {
        const componentDocs = docs[this.props.component.replace('forms/', '')]
            ? docs[this.props.component.replace('forms/', '')].props
            : null;

        return (
            <div className="property-details">
                <h2
                    id="property-details"
                    className="slds-text-heading--medium slds-p-bottom--small"
                >
                    <a
                        href="#property-details"
                        className="slds-text-link--reset site-text-heading--callout"
                    >
                        Property Details
                    </a>
                </h2>
                <p>
                    All public, supported component props are listed below. If
                    you believe there is a clearer way to describe a property,
                    please submit a pull request. Property descriptions are
                    built from source code comments (written in{' '}
                    <a href="https://www.markdownguide.org/">Markdown</a>)
                    located within <code>propTypes</code> objects which are
                    typically found in{' '}
                    <a
                        href={`https://github.com/salesforce/design-system-react/tree/master/components/${this.props.component}`}
                    >
                        each component's
                    </a>{' '}
                    <code>index.jsx</code>. Pull requests to update these
                    descriptions can easily be done without cloning this
                    repository by clicking "Edit this file" in the Github user
                    interface.
                </p>
                <table className="slds-table slds-table--bordered slds-no-row-hover slds-m-top--large slds-border_right slds-border_left">
                    <thead>
                        <tr className="slds-text-title--caps">
                            <th scope="col">Name</th>
                            <th scope="col">Type</th>
                            <th className="site-text--center" scope="col">
                                Required
                            </th>
                            <th scope="col">Default</th>
                            <th scope="col">Description</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderPropInfo(componentDocs)}</tbody>
                </table>
                {this.renderSubComponentInfo()}
            </div>
        );
    }
});

module.exports = PropTable;



// WEBPACK FOOTER //
// ./public/src/components/prop-table.jsx